import { Injectable } from '@angular/core';
import { Answer } from '../models/answers/answer.model';
import { Stodgrund } from '../models/stodgrund.model';

@Injectable({
  providedIn: 'root',
})
export class BudgetService {
  public effektaBudgetAnswer: Answer;
  public effektaProjektStartDate: Date;
  public effektaProjektEndDate: Date;
  public effektaSenastBeslut: Date;
  public effektaTotalFinansiering: number;
  public stodgrunder: Stodgrund[];
  public ansokanSentDate: Date;

  private upparbetadeKostnaderBudget: UpparbetadeKostnaderBudget;
  private rapportBudgetDates: RapportBudgetDates;

  setUpparbetadeKostnaderBudget(
    upparbetadeKostnaderBudget: UpparbetadeKostnaderBudget,
    rapportBudgetDates: RapportBudgetDates,
  ) {
    this.upparbetadeKostnaderBudget = upparbetadeKostnaderBudget;
    this.rapportBudgetDates = rapportBudgetDates;
  }

  getUpparbetadeKostnaderBudget() {
    return this.upparbetadeKostnaderBudget;
  }

  getRapportBudgetDates() {
    return this.rapportBudgetDates;
  }
  getBudgeteratForProjektpart(
    projektpartId: string,
  ): { id: string; budget: number }[] | undefined {
    if (!this.upparbetadeKostnaderBudget) {
      return undefined;
    }

    const projektpart = this.upparbetadeKostnaderBudget.projektparter.find(
      (p) => p.id === projektpartId,
    );
    if (!projektpart) {
      return undefined;
    }
    return projektpart.ackumuleradeKostnader.map((kostnad) => ({
      id: kostnad.kostnadsslag.toString(),
      budget: kostnad.budgeterat,
    }));
  }
}

export interface UpparbetadeKostnaderBudget {
  summaBudgeteradeKostnader: number;
  maxBidrag: number;
  redanAterbetaltBelopp: number;
  ejUtbetaltBelopp: number;
  isBudgetStandard: boolean;
  redovisningsperiodStartDatum: Date;
  redovisningsperiodSlutDatum: Date;
  projektparter: {
    id: string;
    koordinerande: boolean;
    aktiv: boolean;
    summaBudgeteradeKostnader: number;
    summaAckumuleradeKostnader: number;
    maxBidrag: number;
    maxStodniva: number;
    ackumuleradeKostnader: {
      kostnadsslag: number;
      ackumulerat: number;
      budgeterat: number;
    }[];
    upparbetadeKostnader: {
      kostnadsslag: number;
      upparbetadeKostnaderPerAr: {
        ar: number;
        summa: number;
      }[];
      budgeterat: {
        ar: number;
        summa: number;
      }[];
    }[];
  }[];
  totaltAckumuleradeKostnader: {
    kostnadsslag: number;
    ackumulerat: number;
    budgeterat: number;
  }[];
}

export interface RapportBudgetDates {
  projektStartDate: Date;
  projektEndDate: Date;
  redovisningsPerioder: {
    startDate: Date;
    endDate: Date;
  }[];
  ackumuleradeKostnaderStartDate: Date;
  ackumuleradeKostnaderEndDate: Date;
}

export interface TotalUpprapporteradeKostnaderPerYear {
  kostnadsslag: string;
  summaPerYear?: { kostnad: number; budget: number; year: number }[];
}
